import { LOAD_MOVIE_SEARCH_PAGE } from '@/store/protocols'
export default {
    name: 'movies/search',
    path: 'search/:kw/:type?/:page?',
    component: () => import('./Root.vue'),
    meta: {
        asyncData: LOAD_MOVIE_SEARCH_PAGE.join('/')
    }
}